import { CHAINS_COMPETITORS } from '$lib/constants/chainsCompetitors'
import { CHAINS_CONFIG, type ChainConfig } from '$lib/constants/chainsConfig'
import type { ChainSocials } from '$lib/constants/chainsSocials'
import type { ChainData, ChainId } from '$lib/models'

const SOCIALS_ORDER: (keyof ChainSocials)[] = [
	'website',
	'twitter',
	'discord',
	'telegram',
	'reddit',
	'youtube',
	'github',
]

export const getSocials = (socials: ChainSocials, types: (keyof ChainSocials)[] = []) => {
	const socialsArray = SOCIALS_ORDER.reduce(
		(acc, type) => {
			const linkOrLinks = socials[type]

			if (Array.isArray(linkOrLinks)) {
				return [
					...acc,
					...linkOrLinks.map(link => ({
						type,
						link,
					})),
				]
			} else if (typeof linkOrLinks === 'string') {
				return [
					...acc,
					{
						type,
						link: linkOrLinks,
					},
				]
			}
			return acc
		},
		<
			{
				type: keyof ChainSocials
				link: string
			}[]
		>[]
	)

	if (Array.isArray(types) && types.length > 0) {
		return socialsArray.filter(({ type }) => types.includes(type))
	}

	return socialsArray
}

export const getChainCompetitors = (chainId: ChainId) => {
	const chainCompetitors = CHAINS_COMPETITORS[chainId]

	if (!Array.isArray(chainCompetitors) || chainCompetitors.length === 0) {
		return []
	}

	return chainCompetitors.reduce(
		(acc, competitor) => {
			const competitorConfig = CHAINS_CONFIG[competitor]

			if (competitorConfig) {
				return [...acc, competitorConfig]
			}

			return acc
		},
		<ChainConfig[]>[]
	)
}

export const getChainWithBiggestTps = (chains: ChainData[]) => {
	if (chains.length === 0) {
		return null
	}

	return chains.reduce((largest, chain) => {
		if (!chain.tps?.value || !largest.tps?.value) {
			return largest
		}

		if (chain.tps.value > largest.tps.value) {
			return chain
		}

		return largest
	}, chains[0])
}
